import { useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useOutletContext, useParams } from 'react-router-dom';

import { StyledTab, StyledTabs } from '@selfserve/react-ui';
import { useCustomSearchParams } from '@selfserve/react-hooks';
import { productType } from '@selfserve/react-utils';

import { IContextData } from './admin-layout';

import { AdminProductList } from './admin-product-list';
import { StyledPageTitle } from '../ui/admin-styled-components';

const AdminProducts = () => {
  const { t } = useTranslation();
  const { productFamily } = useParams();
  const [query, setQuery] = useCustomSearchParams();
  const { catalogItems } = useOutletContext<IContextData>() || {};
  const tab = useMemo(() => (query['tab'] as string) || '', [query]);
  const products = useMemo(
    () => catalogItems?.[productFamily as string][tab],
    [productFamily, tab, catalogItems]
  );

  useEffect(() => {
    if (!tab) {
      setQuery(
        (prevQuery) => ({
          ...prevQuery,
          tab: productType.PACKAGES,
        }),
        { replace: true }
      );
    }
  }, [tab]);

  const handleSetTab = useCallback(
    (value: string) => () => {
      setQuery((prevQuery) => ({
        ...prevQuery,
        tab: value,
      }));
    },
    [productFamily, setQuery]
  );

  return (
    <div>
      <StyledPageTitle isSmall>{productFamily}</StyledPageTitle>
      <StyledTabs value={tab}>
        <StyledTab
          value={productType.PACKAGES}
          label={t('common.packages')}
          onClick={handleSetTab(productType.PACKAGES)}
          isSmall={false}
          smallMargin
        />
        <StyledTab
          value={productType.ADDONS}
          label={t('common.addons')}
          onClick={handleSetTab(productType.ADDONS)}
          isSmall={false}
          smallMargin
        />
        <StyledTab
          value={productType.PLANS}
          label={t('common.plans')}
          onClick={handleSetTab(productType.PLANS)}
          isSmall={false}
          smallMargin
        />
        <StyledTab
          value={productType.CHARGES}
          label={t('common.charges')}
          onClick={handleSetTab(productType.CHARGES)}
          isSmall={false}
          smallMargin
        />
      </StyledTabs>
      <AdminProductList products={products} tab={tab} />
    </div>
  );
};

export { AdminProducts };
